import Bugsnag from '@bugsnag/js';
import { PaymentVendor } from 'checkout/enums/PaymentVendor';
import { IAvailablePaymentMethods } from 'checkout/types/PaymentMethod';

export const getRecommendedCurrency = ({
  availablePaymentMethods,
  paymentVendor,
  userCurrency,
}: {
  availablePaymentMethods: IAvailablePaymentMethods;
  paymentVendor: PaymentVendor;
  userCurrency: string;
}) => {
  const isAnyCurrencySupported =
    paymentVendor === PaymentVendor.CreditCard || paymentVendor === PaymentVendor.ApplePay;
  if (isAnyCurrencySupported) return userCurrency;

  const userCurrencyIsSupported =
    availablePaymentMethods?.[paymentVendor]?.supportedCurrencies?.includes(userCurrency);
  if (userCurrencyIsSupported) return userCurrency;

  const recommendedCurrency = availablePaymentMethods?.[paymentVendor]?.supportedCurrencies[0];
  if (recommendedCurrency) return recommendedCurrency;

  Bugsnag.leaveBreadcrumb(
    'No recommended currency found. Defaulting to USD',
    { availablePaymentMethods, paymentVendor, userCurrency },
    'process',
  );
  return 'USD';
};
